import { NodeModel } from "@minoru/react-dnd-treeview/dist/types";
import { TagFromTree } from "../models/TrendingModelsV2";

export function buildTagsTreeV2(data: TagFromTree[]): NodeModel<TagFromTree>[] {
	const tagsForTree: NodeModel<TagFromTree>[] = [];

	data.forEach((el) => {
		const tagForTree: NodeModel<TagFromTree> = {
			id: el.TagId,
			parent: el.ParentTagFolderId ?? (el as any).ParentTagId ?? 0,
			text: el.TagName,
			data: el,
			droppable: el.TagTypeCode === "F",
		};
		return tagsForTree.push(tagForTree);
	});
	return tagsForTree;
}
